/***
 *
 *   API Key Editor
 *   Create or edit a new/existing API key
 *
 **********/

import React, { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';
import {
  Animate,
  AccountNav,
  Card,
  Form,
  Message,
  Breadcrumbs,
  TextInput,
  Loader,
  History,
  useAPI,
} from 'components/lib';

export function APIKeyEditor(props) {
  // get the scopes
  const scopes = useAPI('/api/scopes');

  // state
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [newAPIKey, setNewAPIKey] = useState(false);

  const fetch = useCallback(async () => {
    setLoading(true);
    const res = await Axios.get(
      `/api/key/${props?.location?.search?.substring(4)}`,
    );
    res.data.data.length ? setData(res.data.data[0]) : History.push('/404');
    setLoading(false);
  }, [props.location.search]);

  useEffect(() => {
    // editing existing key?
    const id = props?.location?.search;
    if (id) fetch(id);
  }, [fetch, props.location.search]);

  if (scopes.loading) return <Loader />;

  return (
    <Animate>
      <AccountNav />

      <Breadcrumbs
        items={[
          { name: 'API Keys', url: '/account/apikeys' },
          {
            name: `${data ? 'Edit' : 'Create'} API Key`,
            url: '/account/apikeys/create',
          },
        ]}
      />

      {newAPIKey ? (
        <Message
          closable
          title="Your New API Key"
          type="warning"
          buttonText="Back to API Keys"
          buttonLink="/account/apikeys"
          text="Your API key is below. Please store this somewhere safe."
        >
          <TextInput value={newAPIKey} />
        </Message>
      ) : (
        <Card title={`${data ? 'Edit' : 'Create'} API Key`} loading={loading}>
          <Form
            data={{
              name: {
                label: 'Name',
                type: 'text',
                required: true,
                value: data.name,
                errorMessage: 'Please provide a descriptive name for your key.',
              },
              scope: {
                type: 'checkbox',
                label: 'Scope',
                required: true,
                min: 1,
                default: data.scope,
                options: scopes?.data,
                errorMessage: 'Please select at least one scope',
              },
            }}
            url={data ? `/api/key/${data.id}` : '/api/key'}
            method={data ? 'PATCH' : 'POST'}
            buttonText={data ? 'Save Changes' : 'Create New API Key'}
            callback={(res) => {
              !data && setNewAPIKey(res?.data?.data?.full_key);
            }}
          />
        </Card>
      )}
    </Animate>
  );
}
